import { render, staticRenderFns } from "./addPaymentPool.vue?vue&type=template&id=1dace07e"
import script from "./addPaymentPool.vue?vue&type=script&lang=js"
export * from "./addPaymentPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports